// extracted by mini-css-extract-plugin
export default {"title":"index_title_D0917","titleFix":"index_titleFix_Ta9dy","titleInner":"index_titleInner_Wx848"};